import {gql} from '@apollo/client'

export const GET_BULK_FULFILLMENTS = gql`
  query GetBulFulfillments($pageSize: Int, $offset: Int) {
    fulfillmentBatches(first: $pageSize, offset: $offset, orderBy: FULFILLMENT_NUMBER_DESC) {
      nodes {
        status
        fulfillmentNumber
        createdAt
        id
        message
        fulfillmentType
        fulfillmentBatchOrders {
          totalCount
        }
      }
      totalCount
    }
  }
`

export const CREATE_BULK_FULFILLMENT = gql`
  mutation CreateFulfillmentBatch(
    $batch: BatchFulfillmentInput
    $orders: [BatchFulfillmentOrderInput]
  ) {
    createFulfillmentBatch(input: {batch: $batch, orders: $orders}) {
      uuid
    }
  }
`

export const UPDATE_BULK_FULFILLMENT_ORDERS = gql`
  mutation UpdateFulfillmentBatchOrders($orders: [BatchFulfillmentOrderInput]) {
    updateFulfillmentBatchOrders(input: {orders: $orders}) {
      clientMutationId
    }
  }
`

export const UPDATE_BULK_FULFILLMENT_ORDER = gql`
  mutation UpdateFulfillmentBatchOrder($id: UUID!, $patch: FulfillmentBatchOrderPatch!) {
    updateFulfillmentBatchOrder(input: {patch: $patch, id: $id}) {
      clientMutationId
    }
  }
`

export const PUBLISH_FULFILLMENT_BATCH = gql`
  mutation PublishFulfillmentBatch($id: UUID) {
    publishFulfillmentBatch(input: {fulfillmentBatchId: $id}) {
      clientMutationId
    }
  }
`

export const PUBLISH_FULFILLMENT_BATCH_ORDERS = gql`
  mutation PublishFulfillmentBatchOrders($ids: [UUID]!, $fulfillmentBatchId: UUID!) {
    publishFulfillmentBatchOrders(input: {ids: $ids, fulfillmentBatchId: $fulfillmentBatchId}) {
      clientMutationId
    }
  }
`

export const GET_BULK_FULFILLMENT_ORDERS = gql`
  query GetBulFulfillmentOrders($id: UUID!) {
    getOrdersToFulfill(batchId: $id) {
      nodes {
        id
        batchId
        orderNumber
        city
        zipCode
        state
        country
        customerName
        bottles
        totalWeight
        shippingPrice
        status
        message
        fulfillAt
        doc {
          image
          encodedLabel
          packageSlip
        }
        shippingDefinition {
          deliveryMethod
          labelType
          package
          shippingDate
          imageType
          weight {
            units
            value
          }
        }
        fulfillmentId
      }
      totalCount
    }
  }
`

export const CREATE_IN_HOUSE_FULFILLMENT_BATCH = gql`
  mutation CreateInHouseFulfillmentBatch($orderIds: [UUID]) {
    createInHouseFulfillmentBatch(input: {orderIds: $orderIds}) {
      uuid
      clientMutationId
    }
  }
`

export const GET_READY_TO_FULFILL_ORDERS_BY_BATCH_ID = gql`
  query GetReadyToFulfillOrdersByBatchId($batchId: UUID!) {
    getReadyToFulfillOrdersByBatchId(pBatchId: $batchId) {
      nodes {
        id
        batchId
        addressLine1
        addressLine2
        bottles
        city
        countryCode
        deliveryStatus
        customerName
        createdAt
        fulfillmentId
        orderNumber
        stateName
        totalPrice
        totalWeight
        zipCode
        status
        packageSlip
        tracking {
          companyName
          trackingNumber
        }
      }
      totalCount
    }
  }
`

export const UPDATE_IN_HOUSE_FULFILLMENT = gql`
  mutation UpdateInHouseFulfillment(
    $orderId: UUID!
    $fulfillmentId: UUID
    $tracking: TrackingInput
  ) {
    updateInHouseFulfillment(
      input: {pFulfillmentId: $fulfillmentId, pOrderId: $orderId, pTracking: $tracking}
    ) {
      clientMutationId
    }
  }
`
